// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__XTesF","dot":"styles_dot__M3mmD","signers":"styles_signers__kNlNy"};